import { MosaicPath } from './models/mosaic'

export type MosaicDropTargetPosition = 'top' | 'bottom' | 'left' | 'right'
export const MosaicDropTargetPosition = {
  TOP: 'top' as const,
  BOTTOM: 'bottom' as const,
  LEFT: 'left' as const,
  RIGHT: 'right' as const,
}

export interface MosaicDropData {
  path?: MosaicPath
  position?: MosaicDropTargetPosition
  isDocked?: boolean
  isNewWindow?: boolean
}
